module.exports = __webpack_public_path__ + "media/images/subject_img/MUSIC-5e8f210643d5eef8dda4938d835a253f.jpg";